export default function Autocomplete(props) {
    const {label, value, name, placeholder, disabled, data, btnText, onClick, onSelect, onChange, onBlur } = props;

    const onBtnClick = () => {
        if(onClick)onClick();
    }

    const onInputChange = (e) => {
        if(onChange)onChange(e.target.value)
    }

    const onOptionSelect = (opt) => {
        if(onSelect)onSelect(opt);
    }

    return(
        <>
            {label && (
                <label className="label">{label}</label>
            )}
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <input
                    className="input"
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={onInputChange}
                    style={{ minWidth: 0 }}
                    onBlur={onBlur}
                    disabled={disabled}
                />
                {(btnText && onBtnClick) && (
                    <button className="btn-small ghost" type="button" onClick={onBtnClick}>{btnText}</button>
                )}
            </div>

            {data.showSuggestions && (
                <div style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    zIndex: 40,
                    marginTop: 6,
                    background: '#fff',
                    border: '1px solid #e6e9ee',
                    borderRadius: 8,
                    boxShadow: '0 6px 18px rgba(15,23,42,0.06)',
                    maxHeight: 220,
                    overflowY: 'auto',
                    zIndex: 1000
                }}>
                    {data.loading && <div style={{ padding: 10 }} className="meta">Loading...</div>}
                    {!data.loading && data.options.length === 0 && <div style={{ padding: 10 }} className="meta">No matches</div>}
                    {!data.loading && data.options.map(opt => (
                        <div
                            key={opt.id}
                            onClick={() => onOptionSelect(opt)}
                            style={{ padding: '10px 12px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            onMouseDown={(e) => e.preventDefault()}
                        >
                            <div>
                                <div style={{ fontWeight: 600 }}>{opt.name}</div>
                                <div className="small-muted">{opt.email || ''} {opt.mobile ? ` ${opt.mobile}` : ''}</div>
                            </div>
                            <div className="meta">Select</div>
                        </div>
                    ))}
                </div>
            )}
        </>
    )
}